import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import type { ShopTierInput } from '@/lib/api/shop-tier-api'
import { shopTierApi } from '@/lib/api/shop-tier-api'
import { formatApiError } from '@/lib/format-api-error'
import { m } from '@/lib/paraglide/messages'

export const shopTierKeys = {
    all: ['shop-tiers'] as const,
}

export function useShopTiers(opts: { enabled?: boolean } = {}) {
    return useQuery({
        queryKey: shopTierKeys.all,
        queryFn: () => shopTierApi.list(),
        enabled: opts.enabled ?? true,
    })
}

// Lỗi kiểm dữ liệu của form (mã SHOP_TIER_*) do trang hiện cạnh ô nhập; hook
// chỉ báo thành công và làm mới danh sách.
export function useSaveShopTier() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: ({ id, input }: { id?: string; input: ShopTierInput }) =>
            id ? shopTierApi.update(id, input) : shopTierApi.create(input),
        onSuccess: () => {
            toast.success(m.shop_tier_saved())
            void qc.invalidateQueries({ queryKey: shopTierKeys.all })
        },
    })
}

export function useDeleteShopTier() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: (id: string) => shopTierApi.remove(id),
        onSuccess: () => {
            toast.success(m.shop_tier_deleted())
            void qc.invalidateQueries({ queryKey: shopTierKeys.all })
        },
        onError: (err: unknown) => {
            const { title, description } = formatApiError(
                err,
                m.shop_tier_delete_failed(),
            )
            toast.error(title, { description })
        },
    })
}
